import { Paper, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import Flag from '../../../common/components/Flag';
import ClubAvatar from '../../clubs/Avatar';
import { getTeamHref } from '../../teams/utils';
import { ITournamentAward } from '../typings';

const styles = {
  root: {
    padding: 16,
  },
  teamRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16,
  },
  teamIcon: {
    marginRight: 8,
  },
  flag: {
    marginLeft: 8,
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  }
};

interface IProps {
  award: ITournamentAward | null;
  classes: any;
  intl: any;
}

class TournamentAwardDetail extends React.Component<IProps> {

  public render() {
    const { award, classes, intl: { messages: m } } = this.props;
    if (!award?.winnerTeam && !award?.runnerUpTeam) {
      return (
        <Paper elevation={2} className={classes.root}>
          <div>
            <Typography variant="body1" color="textSecondary">
              {m.error_noData}
            </Typography>
          </div>
        </Paper>
      );
    }

    const { winnerTeam, runnerUpTeam } = award;

    return (
      <Paper elevation={2} className={classes.root}>
        <Typography variant="subtitle1" gutterBottom>
          {m.field_winner}
        </Typography>
        {this.renderTeam(winnerTeam, classes)}

        <Typography variant="subtitle1" gutterBottom>
          {m.field_runnerUp}
        </Typography>
        {this.renderTeam(runnerUpTeam, classes)}
      </Paper>
    );
  }

  private renderTeam(team: any, classes: any) {
    if (!team) return '-';

    return (
      <div className={classes.teamRow}>
        <div className={classes.teamIcon}>
          <ClubAvatar club={team.club} />
        </div>
        <a href={getTeamHref(team)} className={classes.link}>
          {team.name}
        </a>
        {team.club?.isSelection && team.club.country && (
          <Flag country={team.club.country} style={styles.flag} />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(TournamentAwardDetail);
